/**
 * Constantes compartidas del módulo Almacén / Inventario.
 * Etiquetas y estilos de tipos de huevo y movimientos.
 */

export const EGG_LABELS = {
  grande: 'Grandes',
  mediano: 'Medianos',
  pequeno: 'Pequeños',
  doble: 'Dobles',
  sucio: 'Sucios',
  casquiado: 'Casquiados',
};

export const EGG_COLORS = {
  grande: 'bg-orange-100 border-orange-300 text-orange-900',
  mediano: 'bg-yellow-100 border-yellow-300 text-yellow-900',
  pequeno: 'bg-yellow-50 border-yellow-200 text-yellow-800',
  doble: 'bg-red-100 border-red-300 text-red-900',
  sucio: 'bg-amber-200/70 border-amber-700/50 text-amber-900',
  casquiado: 'bg-gray-200 border-gray-400 text-gray-800',
};

export const MOVIMIENTO_COLORS = {
  Entrada: 'default',
  Salida: 'destructive',
  Rotura: 'secondary',
  Ajuste: 'outline',
  Reverso: 'outline',
  // Legacy values (registros antiguos)
  Egreso: 'destructive',
  Ingreso: 'default',
};

export const MOVIMIENTO_LABELS = {
  Entrada: '+ Entrada',
  Salida: '− Salida',
  Rotura: '× Rotura',
  Ajuste: '± Ajuste',
  Reverso: '↺ Reverso',
  // Legacy fallbacks
  Egreso: '− Salida',
  Ingreso: '+ Entrada',
};

export const TIPOS_CONTEO = ['grande', 'mediano', 'pequeño', 'doble', 'sucio', 'casquiado'];

export const TIPO_LABELS_CONTEO = {
  grande: 'Grandes',
  mediano: 'Medianos',
  'pequeño': 'Pequeños',
  doble: 'Dobles',
  sucio: 'Sucios',
  casquiado: 'Casquiados',
};

/**
 * Normaliza la clave de tipo de huevo en los datos (maneja legacy "pequeño"→"pequeno").
 */
export const normalizeTipoKey = (tipo) =>
  tipo === 'pequeño' || tipo === 'pequeno' ? 'pequeno' : tipo;
